module.exports = __webpack_public_path__ + "img/page.5465f9c5.png";